import { IElementToSimpleSapElementMapperFactory } from '../IElementToSimpleSapElementMapperFactory';
import Element, { ElementType } from '@/models/element';
import { IElementToSimpleSamElementsMapper } from '../elementToSimpleSapElementsMapper';
import { NullToSimpleSapELementMapper } from '../nullToSimpleSapElementMapper';
import { CtLegsToSimpleSapElementMapper } from './ctLegsToSimpleSapElementMapper';
import { CtBodyToSimpleSapElementMapper } from './ctBodyToSimpleSapElementMapper';

export class CtElementToSimpleSapElementMapperFactory
    implements IElementToSimpleSapElementMapperFactory {

    private body = new CtBodyToSimpleSapElementMapper();
    private legs = new CtLegsToSimpleSapElementMapper();
    private null = new NullToSimpleSapELementMapper();

    public getMapperFor(element: Element): IElementToSimpleSamElementsMapper {
        if (element.type === ElementType.BODY) {
            return this.body;
        }
        if (element.type === ElementType.LEGS) {
            return this.legs;
        }
        return this.null;
    }
}
